<template>
  <div class="login">
    <div class="wavy-line"></div>
    <div class="login-box">
      <div class="login-form-box">
        <div class="toggle-btn" @click="toggleLoginType">
          <div v-show="isPasswordLogin">
            <img src="../assets/img/login/img_QRcode_icon.png" alt="" />
          </div>
          <div v-show="!isPasswordLogin">
            <img src="../assets/img/login/img_PC.png" alt="" />
          </div>
        </div>
        <!-- 账号登录-->
        <div v-show="isPasswordLogin">
          <h4 class="login-box_title">账号登录</h4>
          <a-form :form="form" class="login-form" id="loginForm">
            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="home" class="input-icon"
              /></a-col>
              <a-col :span="21"
                ><a-form-item class="form-item"
                  ><a-input
                    placeholder="请输入企业代码"
                    class="input-item"
                    v-decorator="['code']"
                  >
                  </a-input> </a-form-item
              ></a-col>
            </a-row>

            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="mobile" class="input-icon"
              /></a-col>
              <a-col :span="21">
                <a-form-item class="form-item"
                  ><a-input
                    placeholder="请输入手机号"
                    class="input-item"
                    :maxLength="11"
                    v-decorator="['username']"
                  >
                  </a-input> </a-form-item
              ></a-col>
            </a-row>

            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="lock" class="input-icon"
              /></a-col>
              <a-col :span="21">
                <a-form-item class="form-item"
                  ><a-input
                    placeholder="请输入密码"
                    class="input-item"
                    type="password"
                    v-decorator="['password']"
                  >
                  </a-input> </a-form-item
              ></a-col>
            </a-row>

            <a-row class="form-row">
              <a-col :span="3" class="item-left">
                <a-icon type="safety-certificate" class="input-icon"
              /></a-col>
              <a-col :span="21">
                <a-col :span="15"
                  ><a-form-item class="form-item"
                    ><a-input
                      placeholder="请输入验证码"
                      class="input-item"
                      v-decorator="['captcha']"
                    >
                    </a-input></a-form-item
                ></a-col>
                <a-col :span="9">
                  <a-button
                    type="primary"
                    :disabled="state.smsSendBtn"
                    @click.stop.prevent="getCaptcha"
                    class="sms-button"
                    v-text="
                      (!state.smsSendBtn && '点击获取验证码') ||
                        state.time + ' 秒后重新获取'
                    "
                  ></a-button>
                  <!-- <input type="button" value="点击获取" /> -->
                </a-col>
              </a-col>
            </a-row>
            <div class="box-space">
              <p class="left">
                <router-link :to="{ name: 'AccountActivation' }"
                  >账号激活</router-link
                >
              </p>
              <p>
                <router-link :to="{ name: 'RetrieveThePassword' }"
                  >忘记密码？</router-link
                >
              </p>
            </div>
            <a-form-item>
              <a-button
                type="primary"
                class="login-form-button"
                block
                @click.stop.prevent="onSubmit"
                :disabled="state.submitBtn"
              >
                登录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <!--        扫码登录-->
        <div
          v-show="!isPasswordLogin"
          class="qrcode-container"
          style="width:100%"
        >
          <div v-if="qrStatus === 1" class="qrcode-correct">
            <h4 class="login-box_title">扫码登录</h4>
            <div class="login-boxes">
              <img class="qrcode" :src="qrImgSrc" alt="" />
            </div>
            <div class="login-footer">打开手机销讯通，扫描二维码</div>
          </div>
          <div v-if="qrStatus === 2" class="qrcode-success">
            <h4 class="login-box_title">扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_success_login.png"
                alt=""
              />
            </div>
            <h4 class="login-box_titles">扫描成功!</h4>
            <div>请在APP端确认登录</div>
          </div>
          <div v-if="qrStatus === 3" class="qrcode-error" @click="doQrLogin">
            <h4 class="login-box_title">扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_QRcode_error.png"
                alt=""
              />
              <div class="qrcode-center">点击刷新二维码</div>
            </div>
            <div class="qrcode-error-footer">二维码已失效，请刷新！</div>
          </div>
          <div v-if="qrStatus === 4" class="qrcode-success qrcode-cancel">
            <h4 class="login-box_title">扫码登录</h4>
            <div class="login-boxes">
              <img
                class="qrcode"
                src="../assets/img/login/img_QRcode_cancel.jpg"
                alt=""
              />
            </div>
            <h4 class="login-box_titles">APP取消授权!</h4>
            <div @click="doQrLogin" style="cursor:pointer;">
              点击重新获取二维码
            </div>
          </div>
          <!--          <span v-if="qrStatus === 4">超时</span>-->
        </div>
      </div>
    </div>
    <div
      class="page-footer"
      v-bind:class="{ collapsed: $store.state.collapsed }"
    >
      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司
      <a href="https://beian.miit.gov.cn/" class="beian" target="_blank"
        >沪ICP备14016032号-3</a
      >
    </div>
  </div>
</template>

<script>
import * as apiLogin from '@/api/login'
import RegEx from '@/utils/regex'
import { nonEmptyString } from '@/utils/util'

const ERROR_TIP = {
  code: '请输入企业代码',
  username: '请输入手机号',
  password: '请输入密码',
  captcha: '请输入验证码'
}
export default {
  name: 'login',
  beforeCreate() {
    this.form = this.$form.createForm(this)
    this.currentYear = new Date().getFullYear()
  },
  data: () => ({
    state: {
      smsSendBtn: false,
      time: 60,
      submitBtn: false
    },
    isPasswordLogin: true,
    qr_data: '',
    // 1-正常，2-成功，3-失败
    qrStatus: 1,
    qrImgSrc: '',
    qrTimer: null,
    timeunixStart: '',
    notConfirmTime: []
  }),
  created() {
    // document.onkeydown = e => {
    //   let _key = window.event.keyCode;
    //   if (_key === 13) {
    //     this.onSubmit();
    //   }
    // };
  },
  methods: {
    // 发送验证码
    getCaptcha(e) {
      e.preventDefault()
      const that = this
      if (that.state.isSending) {
        return
      }
      const formValues = this.form.getFieldsValue()

      if (!nonEmptyString(formValues.code)) {
        this.$message.error(ERROR_TIP.code)
        return false
      }
      if (!nonEmptyString(formValues.username)) {
        this.$message.error(ERROR_TIP.username)
        return false
      }
      if (RegEx.mobile.test(formValues.username)) {
        that.state.isSending = true
        const interval = window.setInterval(() => {
          that.state.smsSendBtn = true
          if (that.state.time-- <= 0) {
            that.state.time = 60
            that.state.smsSendBtn = false
            that.state.isSending = false
            window.clearInterval(interval)
          }
        }, 1000)

        const hide = that.$message.loading('验证码发送中..', 0)
        apiLogin
          .getSmsCaptcha({
            username: formValues.username,
            code: formValues.code,
            scene: 1
          })
          .then((res) => {
            if (0 === res.status) {
              setTimeout(hide, 2000)
            } else {
              this.$message.error(res.msg)
              setTimeout(hide, 1)
              window.clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
              that.state.isSending = false
            }
          })
          .catch((err) => {
            setTimeout(hide, 1)
            window.clearInterval(interval)
            that.state.time = 60
            that.state.smsSendBtn = false
            this.requestFailed(err)
            that.state.isSending = false
          })
      } else {
        that.$message.error('手机号格式错误')
      }
    },
    onSubmit() {
      const formValues = this.form.getFieldsValue()
      for (let key in formValues) {
        if (!nonEmptyString(formValues[key])) {
          this.$message.error(ERROR_TIP[key])
          return false
        } else if (
          key === 'username' &&
          !RegEx.mobile.test(formValues.username)
        ) {
          this.$message.error('手机号格式错误')
          return false
        }
      }
      this.state.submitBtn = true
      apiLogin
        .login({
          username: formValues.username,
          password: formValues.password,
          code: formValues.code,
          captcha: formValues.captcha
        })
        .then((res) => {
          if (0 === res.status) {
            // this.state.submitBtn = false;
            this.$router.push({ name: 'home' })
          } else {
            this.state.submitBtn = false
            if (res.status !== 5) {
              this.$message.error(res.msg)
            } else {
              let that = this
              this.$confirm({
                title: res.msg,
                content: '',
                onOk() {
                  window.sessionStorage.setItem(
                    'loginForm',
                    JSON.stringify(formValues)
                  )
                  that.$router.push({ name: 'AccountActivation' })
                },
                onCancel() {}
              })
            }
          }
        })
        .catch((err) => {
          this.requestFailed(err)
        })
    },
    requestFailed(err) {
      const errMsg =
        (err.data && err.data.msg) || err.msg || '请求出现错误，请稍后再试'
      this.$message.error(errMsg)
      this.state.submitBtn = false
    },
    clearQRtimer() {
      clearInterval(this.qrTimer)
      this.qrTimer = null
    },

    doQrLogin() {
      // 缓存一下this，留在计时器中使用
      let that = this

      // 清空旧二维码图片
      this.qrImgSrc = ''

      // 关闭清空计时器
      this.clearQRtimer()

      // 显示二维码扫码状态页面
      this.qrStatus = 1

      // 请求新的二维码内容qr_data
      apiLogin
        .scanQrLogin({
          qr_data: ''
        })
        .then((res) => {
          // console.log(res.status);
          // console.log(res.data.qr_data);
          this.notConfirmTime = []
          // 获取二维码内容成功
          if (2 == res.status) {
            this.qr_data = res.data.qr_data
            this.qrImgSrc =
              this.$axios.defaults.baseURL +
              'jurisdiction/website/login/qrcode?qr_data=' +
              this.qr_data
            this.timeunixStart = new Date().valueOf()
            // 启动计时器，轮询移动端处理状态
            this.qrTimer = setInterval(() => {
              apiLogin
                .scanQrLogin({
                  qr_data: that.qr_data
                })
                .then((res) => {
                  // res.status = 6;
                  // 状态4，移动端未操作
                  if (4 == res.status) {
                    // 5分钟没有扫码，二维码过期
                    if (
                      new Date().valueOf() - this.timeunixStart >
                      1000 * 60 * 5
                    ) {
                      that.clearQRtimer()
                      that.qrImgSrc = ''
                      that.qrStatus = 3
                    }
                    return
                  }

                  // 状态1，移动端二维码错误，显示刷新页面
                  if (1 == res.status) {
                    that.clearQRtimer()
                    that.qrImgSrc = ''
                    that.qrStatus = 3
                    return
                  }
                  // 扫码成功，未确认
                  if (5 == res.status) {
                    that.notConfirmTime.push(new Date().valueOf())
                    // 5分钟没有扫码，二维码过期
                    if (
                      new Date().valueOf() - that.notConfirmTime[0] >
                      1000 * 60 * 2
                    ) {
                      that.clearQRtimer()
                      that.qrImgSrc = ''
                      that.qrStatus = 3
                      return
                    }
                    that.qrImgSrc = ''
                    that.qrStatus = 2
                  }
                  // 扫码成功，app取消登录
                  if (6 == res.status) {
                    that.clearQRtimer()
                    that.qrImgSrc = ''
                    that.qrStatus = 4
                    return
                  }
                  // 状态0，移动端二维码确认登录成功，首页跳转
                  if (0 == res.status) {
                    that.clearQRtimer()
                    // 扫码成功跳转到首页
                    that.$router.push({ name: 'home' })
                    return
                  }
                })
            }, 5000)
          }
        })
    },
    toggleLoginType() {
      this.isPasswordLogin = !this.isPasswordLogin
      if (!this.isPasswordLogin) {
        this.doQrLogin()
      } else {
        this.clearQRtimer()
      }
    }
  },
  //销毁定时器
  destroyed() {
    this.clearQRtimer()
  }
}
</script>

<style lang="less" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('~@/assets/img/login/img_background.png') repeat-x;
  background-size: auto 100%;
  .wavy-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 236px;
    background: url('~@/assets/img/login/img_wavy_line.png') no-repeat;
    background-size: 100% 100%;
  }
  .login-box {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 46px;
    width: 1092px;
    height: 624px;
    transform: translate(-50%, -50%);
    background: url('~@/assets/img/login/img_login_box.png') no-repeat;
    background-size: 100% 100%;
    .login-box_title {
      margin-bottom: 50px;
      text-align: center;
      font-size: 24px;
      color: #008fff;
      font-weight: 400;
    }
    .login-box_titles {
      margin-top: 50px;
      text-align: center;
      font-size: 24px;
      color: #008fff;
      font-weight: 400;
    }
    .login-form-box {
      float: right;
      padding: 80px 78px 10px 78px;
      width: 50%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      .login-form {
        .form-row {
          position: relative;
          margin-bottom: 10px;
          padding: 0 0 6px 0;
          height: 45px;
          &::after {
            position: absolute;
            content: '';
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background: #dfdfdf;
            transform: scale(1, 0.4);
          }
          .form-item {
            margin-bottom: 0;
          }
          .item-left {
            position: relative;
            height: 38px;
            &::after {
              position: absolute;
              content: '';
              right: 0;
              top: 50%;
              transform: translate(0, -50%);
              height: 16px;
              width: 1px;
              background: #dfdfdf;
            }
          }
          .input-icon {
            position: absolute;
            top: 10px;
            left: 10px;
            font-size: 20px;
            color: #9a9a9a;
            z-index: 1;
          }
          .input-item {
            padding-left: 16px;
            border: 0 none;
            font-size: 16px;
            outline: 0 none;
            &:focus {
              outline: none;
              border: 0 none;
              box-shadow: none;
            }
          }
        }
        .login-form-button {
          margin-top: 20px;
          height: 40px;
        }
        .sms-button {
          margin-top: 3px;
          padding: 0 10px;
          font-size: 12px;
        }
      }
      .toggle-btn {
        position: absolute;
        right: 0;
        top: 0;
        width: 80px;
        height: 80px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  @media screen and (-webkit-min-device-pixel-ratio: 2),
    screen and (max--moz-device-pixel-ratio: 2) {
    .login-box {
      background: url('~@/assets/img/login/img_login_box@2x.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
.page-footer {
  position: fixed;
  bottom: 5px;
  left: 0;
  width: 100%;
  text-align: center;
  height: 16px;
  color: #fff;
  font-size: 11px;
  .beian {
    color: #fff;
  }
}
.box-space {
  margin-bottom: 0;
  p {
    display: inline-block;
    width: 49%;
    text-align: right;
    &.left {
      text-align: left;
    }
  }
  a {
    font-size: 12px;
  }
}
.qrcode-container {
  position: relation;
  .qrcode-correct {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .login-boxes {
      position: relative;
      width: 150px;
      height: 150px;
      .qrcode {
        width: 100%;
        height: 100%;
      }
    }
    .login-footer {
      margin-top: 40px;
      color: black;
    }
  }
  .qrcode-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .login-boxes {
      position: relative;
      width: 150px;
      height: 150px;
      .qrcode {
        width: 100%;
        height: 100%;
      }
    }
    div {
      color: black;
    }
  }
  .qrcode-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .login-boxes {
      position: relative;
      width: 150px;
      height: 150px;
      border: 1px solid #cdcdcd;
      padding: 10px;
      .qrcode {
        width: 100%;
        height: 100%;
      }
      .qrcode-center {
        position: absolute;
        top: 43%;
        left: 16%;
      }
    }
    .qrcode-error-footer {
      margin-top: 40px;
    }
  }
  .qrcode-cancel {
    .login-box_titles {
      color: #bf443d;
    }
  }
}
</style>
